import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import DocumentIssuanceMaintenanceCont from "presentation/view/container/DocumentIssuance/DocumentIssuanceContMain";

CommonEntrypoint(<DocumentIssuanceMaintenanceCont/>)